document.addEventListener("DOMContentLoaded", function () {
  const productCards = document.querySelectorAll(".card-wrapper");

  productCards.forEach(function (card) {
    // 确保仅在触控设备上运行
    card.addEventListener("touchstart", function () {
      card.classList.add("touch-hover");

      // 1秒后自动移除效果
      setTimeout(() => {
        card.classList.remove("touch-hover");
      }, 1000);
    });
  });
});
